import { c as _c } from "react/compiler-runtime";
import { type ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@shared-components/shadcn/chart";
import { api } from "@shared-server/api";
import { Bar, CartesianGrid, YAxis, XAxis, Legend, BarChart } from "recharts";
const chartConfig: ChartConfig = {
  count: {
    label: "Messages count per chat with files"
  }
};
interface MessagesCountPerChatWithFilesProps {
  startDate: Date;
  endDate: Date;
}
export const MessagesCountPerChatWithFiles = props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.endDate || $[1] !== props.startDate) {
    t0 = {
      startDate: props.startDate,
      endDate: props.endDate
    };
    $[0] = props.endDate;
    $[1] = props.startDate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const coreMetricsQuery = api.coreMetrics.messagesCountPerChatWithFiles.useQuery(t0);
  let t1;
  if ($[3] !== coreMetricsQuery.data) {
    t1 = coreMetricsQuery.data ?? [];
    $[3] = coreMetricsQuery.data;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const chartData = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="mb-4">{"Messages count per chat with files"}</h2>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CartesianGrid vertical={false} />;
    t4 = <XAxis xAxisId="groupCount" dataKey="groupCount" />;
    t5 = <YAxis yAxisId="count" dataKey="count" interval={1} orientation="left" />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChartTooltip content={<ChartTooltipContent className="w-[150px]" nameKey="date" labelFormatter={_temp} />} />;
    t7 = <Legend />;
    t8 = <Bar yAxisId="count" xAxisId="groupCount" dataKey="count" className="fill-ter-yellow-600" fill="#eaaa00" />;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] !== chartData) {
    t9 = <div>{t2}<ChartContainer config={chartConfig} className="aspect-auto h-[150px] w-full"><BarChart accessibilityLayer={true} data={chartData}>{t3}{t4}{t5}{t6}{t7}{t8}</BarChart></ChartContainer></div>;
    $[12] = chartData;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
function _temp(value) {
  return value;
}